export default __webpack_public_path__ + "static/cabin-tiny-home-2-queens-2-36ac4a184ea16e29ebfc0802352d9e9c.jpg";